import React from 'react';
import { Box } from '../../../../../CommonComponents/OPL/Box/Box';
import { Text } from '../../../../../CommonComponents/OPL/Text/Text';
import { StyledPortfolioReturns } from './PortfolioReturns.styles';
import { formatCurrency } from '../../../../../CommonUtils/formatNumber';

interface Props {
  checked: boolean;
  returns: number[];
}

export const PortfolioReturns: React.FC<Props> = ({ checked, returns }) => {
  return (
    <StyledPortfolioReturns>
      <Box flex={1} />

      {returns.map(returnValue => (
        <Box flex={1} mr="16">
          <Text fontWeight={500} textAlign="right" color={checked ? 'primary.600' : 'neutral.700'}>
            {formatCurrency(returnValue)}
          </Text>
        </Box>
      ))}
    </StyledPortfolioReturns>
  );
};
